import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { Icon } from '@saatva-bits/pattern-library.components.icon'

import { CartContext } from '@/store/cart'

import styles from './styles.module.scss'

const Undo = ({ itemRemoved }) => {
    const { undoRemovedItem } = useContext(CartContext)

    let message = itemRemoved.quantity
    message += itemRemoved.quantity > 1 ? ' items were removed' : ' item was removed'

    const undoItem = async () => {
        await undoRemovedItem('cart')
    }

    return (
        <>
            <div className={styles.undoDescription}>
                <Icon name="circleCheck" className={styles.undoIcon} alt="Add Removed Item" titleId="circleCheckIcon" description='Undo' />
                {message}
            </div>
            <div className={styles.undoAction}>
                <button onClick={undoItem} className={styles.undoLink} data-selector='cartItem_undo'>
                    Undo
                </button>
            </div>
            
        </>
    )
}

Undo.propTypes = {
    itemRemoved: PropTypes.any
}

export default Undo
